<template>
    <div class="order-form">
        <div class="order-form__title">Оформление доставки</div>
        <div class="order-form__description">
            Все поля являются обязательными для заполнения.
        </div>
        <div class="order-form__inputs">
            <div class="order-form__inputs-container">
                <label
                    class="order-form__inputs-label"
                    :class="{ error: $v.phone.$error }"
                >
                    Телефон
                </label>
                <inputBase
                    :value="phone"
                    :class="{
                        'order-form__inputs-input--error error': $v.phone.$error || phone.length < 3,
                    }"
                    placeholder="+7"
                    class="order-form__inputs-input"
                    @input="input_phone($event)"
                />
                <div v-if="$v.phone.$error || phone.length < 3" class="error">
                    * Проверьте номер телефона!
                </div>
            </div>
            <div class="order-form__inputs-container" style="width: 234px">
                <label
                    class="order-form__inputs-label"
                    :class="{
                        error: $v.region.$error || compliteRegion !== region,
                    }"
                >
                    Область
                </label>
                <inputBase
                    :value="region"
                    maxlength="30"
                    class="order-form__inputs-input"
                    :class="{
                        'order-form__inputs-input--error':
                            $v.region.$error || compliteRegion !== region,
                    }"
                    @focus="
                        region = '';
                        house = '';
                        city = '';
                        street = '';
                        flat = '';
                    "
                    @input="input_region($event)"
                />
                <div
                    v-if="suggestionsRegion.length > 0"
                    class="suggestions-wrapper"
                >
                    <div class="suggestions-suggestions">
                        <div
                            v-for="(item, id) in suggestionsRegion"
                            v-if="item.data"
                            :key="id"
                            class="suggestions-suggestions-item"
                            @click="
                                region = item.value;
                                suggestionsRegion = [];
                                compliteRegion = item.value;
                                region_fias_id = item.data.region_fias_id;
                            "
                        >
                            {{ item.value }}
                        </div>
                    </div>
                </div>
                <div v-if="$v.region.$error" class="error">
                    * Это поле обязательное
                </div>
                <div v-if="compliteRegion !== region" class="error">
                    * Выберите область
                </div>
            </div>
            <div class="order-form__inputs-container">
                <label
                    class="order-form__inputs-label"
                    :class="{ error: $v.city.$error || compliteSity !== city }"
                >
                    Город
                </label>
                <inputBase
                    :value="city"
                    maxlength="30"
                    class="order-form__inputs-input"
                    :class="{
                        'order-form__inputs-input--error':
                            $v.city.$error || compliteSity !== city,
                    }"
                    :disabled="!region_fias_id"
                    @focus="
                        city = '';
                        house = '';
                        street = '';
                        flat = '';
                    "
                    @input="input_city($event)"
                />
                <div
                    v-if="suggestionsCity.length > 0"
                    class="suggestions-wrapper"
                >
                    <div class="suggestions-suggestions">
                        <div
                            v-for="(item, id) in suggestionsCity"
                            v-if="item.data.city"
                            :key="id"
                            class="suggestions-suggestions-item"
                            @click="
                                city = item.data.city;
                                suggestionsCity = [];
                                kladr_id = item.data.kladr_id;
                                index = item.data.postal_code;
                                compliteSity = item.data.city;
                            "
                        >
                            {{ item.value }}
                        </div>
                    </div>
                </div>
                <div v-if="$v.city.$error" class="error">
                    * Это поле обязательное
                </div>
                <div v-if="compliteSity !== city" class="error">
                    * Выберите город
                </div>
            </div>
            <div class="order-form__inputs-container">
                <label
                    class="order-form__inputs-label"
                    :class="{
                        error: $v.street.$error || compliteStreet !== street,
                    }"
                >
                    Улица
                </label>
                <inputBase
                    :value="street"
                    :disabled="!kladr_id"
                    maxlength="30"
                    class="order-form__inputs-input"
                    :class="{
                        'order-form__inputs-input--error':
                            $v.street.$error || compliteStreet !== street,
                    }"
                    @focus="
                        street = '';
                        house = '';
                        flat = '';
                    "
                    @input="input_address($event)"
                />
                <div
                    v-if="suggestionsStreet.length > 0"
                    class="suggestions-wrapper"
                >
                    <div class="suggestions-suggestions">
                        <div
                            v-for="(item, id) in suggestionsStreet"
                            v-if="item.data.city"
                            :key="id"
                            class="suggestions-suggestions-item"
                            @click="
                                street = item.value;
                                suggestionsStreet = [];
                                (street_fias_id = item.data.street_fias_id),
                                (compliteStreet = item.value);
                            "
                        >
                            {{ item.value }}
                        </div>
                    </div>
                </div>
                <div v-if="$v.street.$error" class="error">
                    * Это поле обязательное
                </div>
                <div v-if="compliteStreet !== street" class="error">
                    * Выберите улицу
                </div>
            </div>
            <div class="order-form__inputs-container" style="width: 160px;">
                <label
                    class="order-form__inputs-label"
                    :class="{
                        error: $v.house.$error || compliteHouse !== house,
                    }"
                >
                    Номер дома, корпус
                </label>
                <inputBase
                    maxlength="5"
                    :value="house"
                    :disabled="!street_fias_id"
                    style="width: 105px"
                    class="order-form__inputs-input"
                    :class="{
                        'order-form__inputs-input--error':
                            $v.house.$error || compliteHouse !== house,
                    }"
                    @focus="
                        house = '';
                        flat = '';
                    "
                    @input="input_house($event)"
                />
                <div
                    v-if="suggestionsHouse.length > 0"
                    class="suggestions-wrapper"
                >
                    <div class="suggestions-suggestions">
                        <div
                            v-for="(item, id) in suggestionsHouse"
                            v-if="item.data.city"
                            :key="id"
                            class="suggestions-suggestions-item"
                            @click="
                                house = item.value;
                                suggestionsHouse = [];
                                compliteHouse = item.value;
                            "
                        >
                            {{ item.value }}
                        </div>
                    </div>
                </div>
                <div v-if="$v.house.$error" class="error">
                    * Это поле обязательное
                </div>
                <div v-if="compliteHouse !== house" class="error">
                    * Выберите дом
                </div>
            </div>
            <div class="order-form__inputs-container" style="width: 234px;">
                <label
                    class="order-form__inputs-label"
                    :class="{ error: $v.flat.$error }"
                >
                    Квартира/офис
                </label>
                <inputBase
                    maxlength="5"
                    :value="flat"
                    :disabled="!street_fias_id"
                    style="width: 105px"
                    class="order-form__inputs-input"
                    :class="{
                        'order-form__inputs-input--error': $v.flat.$error,
                    }"
                    @input="input_flat($event)"
                />
                <div v-if="$v.flat.$error" class="error">
                    * Это поле обязательное
                </div>
            </div>
        </div>
        <div v-if="error_basket.length > 0" class="error-message">
            <svg v-svg symbol="error-icon" size="24"
                 class="icon"
            />
            Для оформления заказа – удалите недоступные товары из корзины
        </div>
        <div
            v-if="error_basket.length === 0 && point < 0"
            class="error-message"
        >
            <svg v-svg symbol="error-icon" size="24"
                 class="icon"
            />
            Не хватает баллов для офрмления заказа – удалите товары из корзины,
            чтобы сумма баллов заказа уменьшилась
        </div>
        <buttonRed
            :disabled="
                $v.flat.$error ||
                    $v.street.$error ||
                    $v.city.$error ||
                    $v.index.$error ||
                    $v.phone.$error ||
                    disabled ||
                    point < 0 ||
                    error_basket.length > 0 ||
                    phone.length > 12 ||
                    phone.length < 3 ||
                    basket.PRiCE < 400
            "
            style="width: 341px; height: 62px; margin-top: 40px; margin-bottom: 161px"
            @click.native="order"
            v-text="$t('оформить заказ')"
        />
        <Prize_shop_item_modal v-if="isOpen" @close="confirmOrder">
            <h1 slot="header" class="mb-5 pb-3">Проверьте номер телефона!</h1>
            <div slot="body">Мы часто сталкиваемся с проблемой неправильного ввода номера телефона. <br>
                Из-за этого мы не сможем доставить  Вам заказ :(
            </div>
        </Prize_shop_item_modal>
    </div>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import {VueMaskDirective} from 'v-mask';
import {validationMixin} from 'vuelidate';
import inputBase from '@/components/ui/inputs/base/input';
import {required, minLength, maxLength} from 'vuelidate/lib/validators';
import {mapActions, mapGetters} from 'vuex';
import Prize_shop_item_modal from '@/components/view_blocks/Prize_shop/Prize_shop_item_modal.vue';

const isNumber = (value) => {
  const regex = /^([+]?[0-9\s-\(\)]{3,25})*$/i;
  return regex.test(value);
};

export default {
  components: {
    Prize_shop_item_modal,
    buttonRed,
    inputBase,
  },
  directives: {
    mask: VueMaskDirective,
  },
  mixins: [validationMixin],
  validations() {
    return {
      city: {
        required,
        minLengthValue: minLength(3),
      },
      region: {
        required,
        minLengthValue: minLength(3),
      },
      street: {
        required,
        minLengthValue: minLength(3),
      },
      index: {
        required,
        minLengthValue: minLength(6),
      },
      phone: {
        required,
        isNumber,
        maxLengthValue: maxLength(12),
        minLengthValue: minLength(12),
      },
      house: {
        required,
      },
      flat: {
        required,
      },
    };
  },
  data() {
    return {
      phone            : '+7',
      city             : '',
      region           : '',
      isOpen           : false,
      isConfirm        : false,
      compliteSity     : '',
      compliteRegion   : '',
      region_fias_id   : '',
      street           : '',
      compliteStreet   : '',
      flat             : '',
      compliteHouse    : '',
      suggestionsCity  : '',
      suggestionsRegion: '',
      suggestionsHouse : '',
      house            : '',
      kladr_id         : null,
      street_fias_id   : null,
      suggestionsStreet: '',
      token            : '54c414f5159776172db8eb00b422c3f298aa3673',
    };
  },
  computed: {
    ...mapGetters('order/Basket', ['basket', 'error_basket']),
    point() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user.points - this.basket.PRiCE;
    },
    phoneMask() {
      return '+7(###)-###-##-##';
    },
    indexMask() {
      return '######';
    },
    disabled() {
      if (
        this.phone &&
                !this.$v.phone.$error &&
                this.city &&
                this.index &&
                this.street &&
                this.flat !== ''
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapActions('order/Basket', ['set_order']),
    order() {
      const id = localStorage.getItem('basket');
      const {phone, city, street, flat, house, region} = this;
      const value = {
        phone,
        city,
        region,
        street : `${street} ${house}`,
        flat   : flat,
        id,
        comment: 'test comment',
      };
      if (
        !this.disabled &&
                this.point >= 0 &&
                this.compliteSity === this.city &&
                this.compliteStreet === this.street &&
                this.compliteHouse === this.house &&
                this.isConfirm
      ) {
        this.set_order(value);
      } else {
        this.isOpen = true;
      }
    },
    confirmOrder() {
      this.isOpen = false;
      this.isConfirm = true;
    },
    input_address($event) {
      this.street = $event.target.value.trim();
      const searchStreet = fetch(
          'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
          {
            method : 'POST',
            headers: {
              'Content-Type' : 'application/json',
              'Accept'       : 'application/json',
              'Authorization': 'Token ' + this.token,
            },
            body: JSON.stringify({
              query         : this.street,
              count         : 10,
              from_bound    : {value: 'street'},
              to_bound      : {value: 'street'},
              restrict_value: true,
              locations     : {kladr_id: this.kladr_id},
            }),
          }
      )
          .then((response) => response.json())
          .then((result) => (this.suggestionsStreet = result.suggestions))
          .catch((error) => console.log('error', error));

      this.$v.street.$touch();
    },
    input_city($event) {
      this.city = $event.target.value.trim();
      const searchCity = fetch(
          'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
          {
            method : 'POST',
            headers: {
              'Content-Type' : 'application/json',
              'Accept'       : 'application/json',
              'Authorization': 'Token ' + this.token,
            },
            body: JSON.stringify({
              query         : $event.target.value.trim(),
              count         : 10,
              from_bound    : {value: 'city'},
              to_bound      : {value: 'city'},
              locations     : {region_fias_id: this.region_fias_id},
              restrict_value: true,
            }),
          }
      )
          .then((response) => response.json())
          .then((result) => (this.suggestionsCity = result.suggestions))
          .catch((error) => console.log('error', error));

      this.$v.city.$touch();
    },
    input_region($event) {
      this.region = $event.target.value.trim();
      const searchRegion = fetch(
          'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
          {
            method : 'POST',
            headers: {
              'Content-Type' : 'application/json',
              'Accept'       : 'application/json',
              'Authorization': 'Token ' + this.token,
            },
            body: JSON.stringify({
              query     : $event.target.value.trim(),
              count     : 10,
              from_bound: {value: 'region'},
              to_bound  : {value: 'area'},
            }),
          }
      )
          .then((response) => response.json())
          .then((result) => (this.suggestionsRegion = result.suggestions))
          .catch((error) => console.log('error', error));

      this.$v.region.$touch();
    },
    input_phone($event) {
      if ($event.target.value[0] === '8') {
        this.phone = $event.target.value.trim().replace('8', '+7');
        this.$v.phone.$touch();
        return;
      }
      this.phone = $event.target.value.trim();
      this.$v.phone.$touch();
    },
    input_flat($event) {
      this.flat = $event.target.value.trim();
      this.$v.flat.$touch();
    },
    input_house($event) {
      this.house = $event.target.value.trim();
      const searchHouse = fetch(
          'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
          {
            method : 'POST',
            headers: {
              'Content-Type' : 'application/json',
              'Accept'       : 'application/json',
              'Authorization': 'Token ' + this.token,
            },
            body: JSON.stringify({
              query         : this.house,
              count         : 10,
              from_bound    : {value: 'house'},
              locations     : {street_fias_id: this.street_fias_id},
              restrict_value: true,
            }),
          }
      )
          .then((response) => response.json())
          .then((result) => (this.suggestionsHouse = result.suggestions))
          .catch((error) => console.log('error', error));
      this.$v.house.$touch();
    },
  },
};
</script>

<style scoped lang="sass">

.clear
  padding: 5px 0
  text-align: center
  cursor: pointer
  transition: color 0.3s ease-in-out

  &:hover
    color: #E4183E

.suggestions-wrapper
  position: relative
  margin: 0
  padding: 0
  vertical-align: top
  -webkit-text-size-adjust: 100%

.suggestions-suggestions
  background: #fff
  border: 1px solid #999
  box-sizing: border-box
  cursor: default
  left: 0
  min-width: 100%
  position: absolute
  z-index: 9999
  height: 150px
  overflow: auto

  &-item
    text-align: center
    padding: 10px 0
    cursor: pointer

    &:hover
      background-color: #e5dfdf

.icon
  margin: 0 12px 0 0

.error-message
  max-width: 530px
  width: 100%
  font-size: 16px
  color: #E4183E
  font-weight: 300
  line-height: 17px
  font-family: 'Futura FuturisC Light'
  margin-top: 15px
  display: flex
  align-items: center

.error
    color: #E4183E

.order-form
  padding-top: 44px
  max-width: 1135px
  width: 100%

  &__title
    font-size: 48px
    font-weight: 400
    line-height: 58px
    color: #4A4A4A

  &__description
    font-size: 16px
    color: #4A4A4A
    font-weight: 300
    line-height: 17px
    padding: 12px 0 20px 0
    font-family: 'Futura FuturisC Light'

  &__inputs
    display: flex
    flex-direction: row
    max-width: 1000px
    width: 100%
    flex-wrap: wrap
    margin-left: -12px

    &-container
      padding: 20px 12px
      display: flex
      flex-direction: column
      max-width: 363px
      width: 100%

    &-label
      font-weight: 300
      font-size: 14px
      line-height: 15px
      color: #4A4A4A
      margin: 0 0 12px 0
      font-family: 'Futura FuturisC Light'
</style>
